import { Box } from '@mui/material'
import { format } from 'date-fns'
import { useState } from 'react'

import { SubheaderText, Text } from '@/components/IncomeCard/TrustedSources/styles'
import { Colours } from '@/utils/styles'

export interface ConnectionFailure {
  timestamp: string
  reason: string
}

interface Props {
  failures: ConnectionFailure[]
}

const TechnicalIssuesSection: React.FC<Props> = ({ failures }) => {
  const [expanded, setExpanded] = useState<boolean>(false)

  return (
    <Box>
      <Box
        onClick={() => setExpanded(!expanded)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          cursor: 'pointer',
        }}
      >
        <SubheaderText variant="subtitle2" sx={{ marginBottom: 0 }}>
          Technical issues ({failures.length})
        </SubheaderText>
        <Box
          sx={{
            width: '20px',
            height: '20px',
            transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.15s ease',
          }}
        >
          <img
            src="/assets/svg/collapse.svg"
            alt=""
            style={{ width: '20px', height: '20px' }}
          />
        </Box>
      </Box>
      {expanded && (
        <Box
          sx={{
            background: Colours.lightGrey,
            borderRadius: '10px',
            padding: '15px',
            display: 'grid',
            gap: '8px',
            marginTop: '8px',
          }}
        >
          {failures.map(response => (
            <Box
              key={response.timestamp}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
              }}
            >
              <Box sx={{ display: 'flex', flex: 1 }}>
                <Text variant="body2" sx={{ flexShrink: 0, mr: '6px' }}>
                  •
                </Text>
                <Text variant="body2">{response.reason}</Text>
              </Box>
              <Text variant="body2" sx={{ whiteSpace: 'nowrap', ml: 2 }}>
                {format(new Date(response.timestamp), "dd/MM/yyyy 'at' HH:mm")}
              </Text>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  )
}

export default TechnicalIssuesSection
